import { Box } from "@mui/material";
import { FormLabel } from "../atoms/FormInput";

type FilterElementprops = {
  render: any;
  title?: string;
};

export const FilterElement = ({ render, title }: FilterElementprops) => {
  return (
    <Box sx={{ display: "grid", gap: "12px" }} className="filter-element">
      {!!title && <FormLabel label={title} error={false} />}
      {render()}
    </Box>
  );
};
